import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert'

import { AudienceGroup, AddRequirementGroupSection } from "./RequirementComponents";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { updatePrice, PriceDisplay } from "./PriceDisplay";
import GeographyIcon from "../../../../../../../assets/images/researcher_app/create/audience_geography_icon.svg";
import DemographicIcon from "../../../../../../../assets/images/researcher_app/create/audience_demographic_icon.png";
import CryptoUsageIcon from "../../../../../../../assets/images/researcher_app/create/audience_crypto_usage_icon.png";
import OnChainIcon from "../../../../../../../assets/images/researcher_app/create/audience_on_chain_icon.png";

import { AddRequirementsSideBar, SideBarContent, WalletSideBarContent } from "./SideBar";

// API Calls
import RequirementsAPI from "../../../api/api_calls/RequirementsAPI";
import RequirementGroupsAPI from "../../../api/api_calls/RequirementGroupsAPI";
import MissionsAPI from "../../../api/api_calls/MissionAPI";

// function AudienceRequirements(props) {

//     const navigate = useNavigate();
//     const alert = useAlert();

//     const [loadingRequirements, setLoadingRequirements] = useState(true);
//     const [loadingNewRequirements, setLoadingNewRequirements] = useState(true);
//     const [availableRequirements, setAvailableRequirements] = useState([]);
//     const [requirementGroups, setRequirementGroups] = useState([]);
//     const [totalMissionSpots, setTotalMissionSpots] = useState(null);

//     const { missionId } = useParams()
//     const [price, setPrice] = useState(null);
//     const [totalPrice, setTotalPrice] = useState(null);


//     function updatePriceWrapper() {
//         updatePrice(setPrice, setTotalPrice, missionId, navigate, alert);
//     }

//     useEffect(() => {
//         // Enable tooltips
//         const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
//         const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

//         async function getRequirements() {
//             const result = await RequirementGroupsAPI.index(missionId, navigate);

//             if (result.success) {
//                 if (result.requirement_groups.length == 0) {
//                     onAddAudience();
//                 } else {
//                     setRequirementGroups(result.requirement_groups);
//                 }
//                 setLoadingRequirements(false);
//             } else {
//                 alert.show(result.error, { type: 'error' })
//             }
//         }

//         async function getNewRequirements() {
//             const result = await RequirementsAPI.new(missionId, navigate);

//             if (result.success) {
//                 setAvailableRequirements(result.available_requirements);
//                 setLoadingNewRequirements(false);
//             } else {
//                 alert.show(result.error, { type: 'error' })
//             }
//         }

//         async function getSessionDetails() {
//             const result = await MissionsAPI.show(missionId, navigate);

//             if (result.success) {
//                 if (result.mission.num_total_spots != null) {
//                     setTotalMissionSpots(result.mission.num_total_spots * 1);
//                 }
//             } else {
//                 alert.show(result.error, { type: 'error' })
//             }
//         }

//         getRequirements();
//         getNewRequirements();
//         getSessionDetails();
//         updatePriceWrapper();
//     }, []);




//     // Function to remove a requirement from the requirementGroups state
//     function onClickDestroy(requirementId, requirementGroupId) {
//         async function destroyRequirement() {
//             const result = await RequirementsAPI.destroy(missionId, requirementId, navigate);

//             if (result.success) {
//                 removeRequirement(requirementId, requirementGroupId);
//                 updatePriceWrapper();
//             } else {
//                 alert.show(result.error, { type: 'error' })
//                 navigate(0);
//             }
//         }

//         destroyRequirement();
//     }

//     function onClickDestroyGroup(requirementGroupId) {
//         async function destroyRequirementGroup() {
//             const result = await RequirementGroupsAPI.destroy(missionId, requirementGroupId, navigate);

//             if (result.success) {
//                 const newRequirementGroups = requirementGroups.filter((group) => group.id != requirementGroupId);
//                 setRequirementGroups(newRequirementGroups);
//                 updatePriceWrapper();
//             } else {
//                 alert.show(result.error, { type: 'error' })
//             }
//         }

//         if (window.confirm("Are you sure you want to delete this audience?")) {
//             if (typeof (requirementGroupId) == "string" && requirementGroupId.includes("temp")) {
//                 const newRequirementGroups = requirementGroups.filter((group) => group.id != requirementGroupId);
//                 setRequirementGroups(newRequirementGroups);
//             } else {
//                 destroyRequirementGroup();
//             }
//         }

//     }

//     function removeRequirement(requirementId, requirementGroupId) {
//         const newRequirementGroups = requirementGroups.map((group) => {
//             if (group.id == requirementGroupId) {
//                 // Remove the requirement from the group
//                 // RequirementGroups has a "full_requirement_list" attribute that contains all the requirements
//                 // Within that is five arrays of requirements, one for each type
//                 // We need to remove the requirement from the correct array
//                 const newFullRequirementList = Object.keys(group.full_requirement_list)
//                     .filter(key => Array.isArray(group.full_requirement_list[key]))  // Ensure the property is an array
//                     .reduce((acc, key) => {
//                         // Filter each array to exclude the specified requirementId
//                         acc[key] = group.full_requirement_list[key].filter(requirement => requirement.id !== requirementId);
//                         return acc;
//                     }, {});
//                 return { ...group, full_requirement_list: newFullRequirementList };
//             } else {
//                 return group;
//             }
//         });

//         setRequirementGroups(newRequirementGroups);
//     }

//     function onAddAudience() {
//         async function createNewGroup() {
//             const newGroupResult = await RequirementGroupsAPI.new(missionId, navigate);
//             if (newGroupResult.success) {
//                 const newGroup = newGroupResult.requirement_group;
//                 newGroup.id = "temp_" + (requirementGroups.length + 1);
//                 newGroup.name = "Audience " + (requirementGroups.length + 1);
//                 // Add the newGroupResult.requirement_group to the current requirementGroups array.
//                 setRequirementGroups([...requirementGroups, newGroup]);
//             } else {
//                 alert.show(newGroupResult.error, { type: 'error' })
//             }
//         }
//         createNewGroup()
//     }

//     function onClickUpdateMaxSessions(requirementGroupId, maxSessions) {
//         async function updateMaxSessions(cleanedMaxSessions) {
//             const result = await RequirementGroupsAPI.update({ missionId, requirementGroupId, maxSessions: cleanedMaxSessions, navigate });

//             if (result.success) {
//                 updateMaxSessionsInState(requirementGroupId, cleanedMaxSessions);
//                 updatePriceWrapper();
//                 alert.show("Max sessions updated", { type: 'success' })
//             } else {
//                 alert.show(result.error, { type: 'error' })
//             }
//         }
//         async function createNewGroup(cleanedMaxSessions, name) {
//             const newGroupResult = await RequirementGroupsAPI.create({ missionId, maxSessions: cleanedMaxSessions, name, navigate });
//             if (newGroupResult.success) {
//                 const newGroup = newGroupResult.requirement_group;
//                 // Add the newGroupResult.requirement_group to the current requirementGroups array 
//                 // and remove the existing group that was identified by requirementGroupId
//                 const newRequirementGroups = requirementGroups.filter((group) => group.id != requirementGroupId);
//                 setRequirementGroups([...newRequirementGroups, newGroup]);
//                 alert.show("Max sessions updated", { type: 'success' })
//             } else {
//                 alert.show(newGroupResult.error, { type: 'error' })
//             }
//         }

//         // If max sessions are empty, set to null.
//         // MaxSessions 
//         const cleanedMaxSessions = maxSessions == "" ? null : maxSessions
//         if (cleanedMaxSessions != null && cleanedMaxSessions < 1) { alert.show("Max sessions must be at least 1", { type: 'error' }) }
//         else if (cleanedMaxSessions != null && cleanedMaxSessions > totalMissionSpots) { alert.show("Max sessions cannot exceed the total project spots (" + totalMissionSpots + ")", { type: 'error' }) }
//         else {
//             if (typeof requirementGroupId === 'string' && requirementGroupId.includes("temp")) {
//                 // If it's not yet saved, save it. 
//                 const name = requirementGroups.find((group) => group.id == requirementGroupId).name;
//                 createNewGroup(cleanedMaxSessions, name);
//             } else {
//                 updateMaxSessions(cleanedMaxSessions);
//             }
//         }
//     }

//     function updateMaxSessionsInState(requirementGroupId, maxSessions) {
//         const newRequirementGroups = requirementGroups.map((group) => {
//             if (group.id == requirementGroupId) {
//                 return { ...group, max_sessions: maxSessions }
//             } else {
//                 return group;
//             }
//         });
//         setRequirementGroups(newRequirementGroups);

//     }


//     const returnData = (<div className="existing-and-new-requirements-container">
//         {loadingRequirements || loadingNewRequirements ?
//             <CenteredLoadingIcon />
//             :
//             <div className="requirement-groups-container">
//                 <PriceDisplay title="Price per Session" price={price} />
//                 {/* Map of each requirement group */}
//                 {requirementGroups.map((requirementGroup) => {
//                     return <AudienceGroup
//                         key={requirementGroup.id}
//                         requirementGroup={requirementGroup}
//                         onClickDestroyGroup={onClickDestroyGroup}
//                         onClickDestroy={onClickDestroy}
//                         showMaxSessions={requirementGroups.length > 1}
//                         availableRequirements={availableRequirements}
//                         updatePrice={updatePriceWrapper()}
//                         totalMissionSpots={totalMissionSpots}
//                         onClickUpdateMaxSessions={onClickUpdateMaxSessions}
//                     />
//                 })}
//                 <AddRequirementGroupSection onAddAudience={onAddAudience} />
//             </div>
//         }
//     </div>);


//     return (
//         <>{returnData} </>
//     )

// }









function AudienceRequirementsCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    const [loadingRequirements, setLoadingRequirements] = useState(true);
    const [loadingNewRequirements, setLoadingNewRequirements] = useState(true);
    const [availableRequirements, setAvailableRequirements] = useState([]);
    const [requirementGroups, setRequirementGroups] = useState([]);
    const [totalMissionSpots, setTotalMissionSpots] = useState(null);
    const [savingRequirements, setSavingRequirements] = useState(false);

    const activeRequirements = requirementGroups[0] != null ? requirementGroups[0].full_requirement_list : null;
    const requirementGroupId = requirementGroups[0] != null ? requirementGroups[0].id : null;
    const geographic_requirements = activeRequirements != null ? activeRequirements.geography : null;
    const demographic_requirements = activeRequirements != null ? activeRequirements.demographics : null;
    const crypto_usage_requirements = activeRequirements != null ? activeRequirements.crypto_usage : null;
    const wallet_requirements = activeRequirements != null ? activeRequirements.wallet : null;

    const [activeSideBar, setActiveSideBar] = useState(null);

    async function getRequirements() {
        const result = await RequirementGroupsAPI.index(missionId, navigate);

        if (result.success) {
            if (result.requirement_groups.length == 0) {
                // onAddAudience();
            } else {
                setRequirementGroups(result.requirement_groups);
            }
            setLoadingRequirements(false);
        } else {
            alert.show(result.error, { type: 'error' })
        }
    }

    useEffect(() => {
        // Enable tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

        // So what we want back here ( per requirement group)
        // A list that matches the ordering of the new requirements
        // So it comes back with 

        async function getNewRequirements() {
            const result = await RequirementsAPI.new(missionId, navigate);

            if (result.success) {
                setAvailableRequirements(result.available_requirements);
                setLoadingNewRequirements(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        async function getSessionDetails() {
            const result = await MissionsAPI.show(missionId, navigate);

            if (result.success) {
                if (result.mission.num_total_spots != null) {
                    setTotalMissionSpots(result.mission.num_total_spots * 1);
                }
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getRequirements();
        getNewRequirements();
        getSessionDetails();
        props.updatePrice();
    }, []);


    function bulkSaveRequirements(requirementCategory, requirements, callbackFunction) {
        async function bulkUpdateRequirements() {
            var result;
            if (requirementCategory == "wallet") {
                result = await RequirementsAPI.bulkWalletUpdate({ missionId, requirementCategory: requirementCategory, requirements: requirements, requirementGroupId: requirementGroupId, navigate });
            } else {
                result = await RequirementsAPI.bulkUpdate({ missionId, requirementCategory: requirementCategory, requirements: requirements, requirementGroupId: requirementGroupId, navigate });
            }

            if (result.success) {
                getRequirements();
                props.updatePrice();
                callbackFunction(true, "Successfully saved requirements");
                window.scrollTo(0, 0)
            } else {
                callbackFunction(false, result.error);
            }
        }
        setSavingRequirements(true)
        bulkUpdateRequirements();
    }

    // function bulkSaveWalletRequirements(requirementCategory, requirements, callbackFunction) {
    //     async function bulkUpdateRequirements() {
    //         const result = await RequirementsAPI.bulkWalletUpdate({ missionId, requirementCategory: requirementCategory, requirements: requirements, requirementGroupId: requirementGroupId, navigate });

    //         if (result.success) {
    //             getRequirements();
    //             props.updatePrice();
    //             callbackFunction(true, "Successfully saved requirements");
    //             window.scrollTo(0, 0)
    //         } else {
    //             callbackFunction(false, result.error);
    //         }
    //     }
    //     setSavingRequirements(true)
    //     bulkUpdateRequirements();
    // }

    function SideBarContentSwitcher() {
        console.log("Crypto Usage Requirements: ", crypto_usage_requirements)
        console.log("Geo Requirements: ", geographic_requirements)
        console.log("Demo Requirements: ", demographic_requirements)
        console.log("Wallet Requirements: ", wallet_requirements)
        console.log("Availble Requirements: ", availableRequirements)

        // console.log("RequirementGroups: ", requirementGroups)
        const open = activeSideBar != null;

        useEffect(() => {
            if (open) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'unset';
            }
        }, [open]);

        return (
            // Needs: Icon, Title, The current reqs, the available reqs.
            // Needs to understand that onchain usage is shown differently.
            <>
                {loadingNewRequirements ? <CenteredLoadingIcon /> :
                    <AddRequirementsSideBar isOpen={open} >
                        {activeSideBar == "geography" && <SideBarContent activeRequirements={geographic_requirements} availableRequirements={availableRequirements["requirements"]["geography"]} icon={GeographyIcon} toggleModal={() => setActiveSideBar(null)} savingRequirements={savingRequirements} bulkSaveRequirements={bulkSaveRequirements} category="geographic" />}
                        {activeSideBar == "demographics" && <SideBarContent activeRequirements={demographic_requirements} availableRequirements={availableRequirements["requirements"]["demographics"]} icon={DemographicIcon} toggleModal={() => setActiveSideBar(null)} savingRequirements={savingRequirements} bulkSaveRequirements={bulkSaveRequirements} category="demographic" />}
                        {activeSideBar == "crypto_usage" && <SideBarContent activeRequirements={crypto_usage_requirements} availableRequirements={availableRequirements["requirements"]["crypto_usage"]} icon={CryptoUsageIcon} toggleModal={() => setActiveSideBar(null)} savingRequirements={savingRequirements} bulkSaveRequirements={bulkSaveRequirements} category="crypto_usage" />}
                        {activeSideBar == "wallet" && <WalletSideBarContent activeRequirements={wallet_requirements} availableRequirements={availableRequirements["requirements"]["wallet"]} icon={OnChainIcon} toggleModal={() => setActiveSideBar(null)} savingRequirements={savingRequirements} bulkSaveRequirements={bulkSaveRequirements} category="wallet" />}
                    </AddRequirementsSideBar>
                }

            </>
        )
    }

    const requirementGroup = requirementGroups[0];
    const availableGeographicReqs = !loadingNewRequirements && availableRequirements && availableRequirements["requirements"]["geography"]["options"]
    const availableDemographicReqs = !loadingNewRequirements && availableRequirements && availableRequirements["requirements"]["demographics"]["options"]
    const availableCryptoUsageReqs = !loadingNewRequirements && availableRequirements && availableRequirements["requirements"]["crypto_usage"]["options"]
    const availableWalletReqs = !loadingNewRequirements && availableRequirements && availableRequirements["requirements"]["wallet"]

    // For crypto usage particularly - we're parsing it as follows. 
    // The "familiar" category stays as is
    // The rest of them are parsed into either included or excluded, based on whether the category ahs true or false
    // So, it'd be parsed into {"Crypto Usage Traits: {selected: [has_wallet, created_contract], exclude: [created_nfts]}}
    // const parsedCryptoUsageReqs = crypto_usage_requirements != null ? Object.keys(crypto_usage_requirements).map((key) => {
    //     if (key == "familiar") {
    //         return { [key]: crypto_usage_requirements[key] }
    //     } else {
    //         // crypto_usage_requirements[key] is either true or false.
    //         // If true, then we add it to selected, if false, we add it to excluded.
    //         if (crypto_usage_requirements[key]) {
    //             // Add it to "selected".
    //             return { "Crypto Usage Traits": { selected: [key] } }
    //         } else {
    //             return { "Crypto Usage Traits": { excluded: [key] } }
    //         }
    //     }
    // }
    // ) : null;
    const parsedCryptoUsageReqs = parseCryptoUsageReqs(availableCryptoUsageReqs, crypto_usage_requirements)
    console.log("Parsed Crypto Usage Reqs: ", parsedCryptoUsageReqs)

    return (
        <div className="audience-requirements-card">
            <AudienceCardTitleAndSubtitle title="Audience Criteria" subtitle="No audience criteria selected." />
            <div className="audience-requirements-req-cards-list">
                {/* TO ADD: AddFunction DestroyFunction ShowSideBarFunction */}
                {loadingNewRequirements || loadingRequirements ? <CenteredLoadingIcon /> :
                    <>
                        <AudienceRequirementsIndividualCard icon={GeographyIcon} requirements={geographic_requirements} title="Geographic" category="geographic" availableRequirements={availableGeographicReqs} description="Global" onAdd={() => setActiveSideBar("geography")} />
                        <AudienceRequirementsIndividualCard icon={DemographicIcon} requirements={demographic_requirements} title="Demographics" category="demographic" availableRequirements={availableDemographicReqs} description="No criteria selected" onAdd={() => setActiveSideBar("demographics")} />
                        <AudienceRequirementsIndividualCard icon={CryptoUsageIcon} requirements={parsedCryptoUsageReqs} title="Crypto Usage" category="crypto_usage" availableRequirements={availableCryptoUsageReqs} description="No criteria selected" onAdd={() => setActiveSideBar("crypto_usage")} />
                        <AudienceRequirementsIndividualCard icon={OnChainIcon} requirements={wallet_requirements} title="On-chain Activity" category="wallet" availableRequirements={availableWalletReqs} description="No criteria selected" onAdd={() => setActiveSideBar("wallet")} />
                    </>
                }
            </div>
            {!loadingNewRequirements && <SideBarContentSwitcher />}
        </div>
    )
}

function AudienceCardTitleAndSubtitle(props) {
    return (
        <div className="audience-requirements-card-title-and-subtitle">
            <div className="audience-requirements-card-title">
                {props.title}
            </div>
            <div className="audience-requirements-card-subtitle">
                {props.subtitle}
            </div>
        </div>
    )
}

function AudienceRequirementsIndividualCard(props) {
    const empty = props.requirements == null || Object.keys(props.requirements).length === 0;

    return (
        <> {empty ?
            <div className="audience-requirements-individual-card">
                <div className="req-individual-card-overview-div">
                    <div className="req-individual-card-title-and-icon-div">
                        <img src={props.icon} height={32} width={32} />
                        <div className="req-individual-card-title">{props.title}</div>
                    </div>
                    <div className="req-individual-card-description">{props.description}</div>
                </div>
                <div className="req-individual-card-cta-div">
                    <TertiaryPlusLink text="Add Requirement" onClick={props.onAdd} />
                </div>
            </div>
            :
            <div className="audience-requirements-individual-card-full">
                <div className="audience-requirements-individual-card-full-header">
                    <div className="req-individual-card-overview-div">
                        <div className="req-individual-card-title-and-icon-div">
                            <img src={props.icon} height={32} width={32} />
                            <div className="req-individual-card-title">{props.title}</div>
                        </div>
                    </div>
                    <div className="req-individual-card-cta-div">
                        <TertiaryEditLink text="Edit Requirements" onClick={props.onAdd} />
                    </div>
                </div>
                <div className="audience-requirements-individual-card-requirements-container">
                    {/* Okay, we're iterating through the sub-categories. E.g. regions and countries, or familiar and defi_activities_used */}
                    {props.category == "wallet" ?
                        props.requirements.map(requirement => {
                            return <WalletRequirementCard key={requirement["type"] + "-" + requirement["id"]} requirement={requirement} />
                        }
                        )

                        :
                        Object.keys(props.requirements).map((key) => {
                            console.log("Key: ", key)
                            console.log("Props.Requirements: ", props.requirements)
                            console.log("Available Requirements: ", props.availableRequirements)
                            return <DisplayRequirementCard key={key} title={key} category={props.category} availableRequirements={props.availableRequirements[key]} requirement={props.requirements[key]} />
                        }

                        )}
                </div>
            </div>
        }
        </>
    )
}

function parseCryptoUsageReqs(availableCryptoUsageReqs, crypto_usage_requirements) {
    return crypto_usage_requirements != null && availableCryptoUsageReqs ? Object.keys(crypto_usage_requirements).reduce((acc, key) => {
        if (key === "familiar") {
            acc[key] = crypto_usage_requirements[key];
        } else {
            console.log("Available Requirements for parsing: ", availableCryptoUsageReqs)
            const label = availableCryptoUsageReqs[key].label;
            if (crypto_usage_requirements[key] == "true") {
                // Add it to "selected".
                if (!acc["Crypto Usage Requirements"]) {
                    acc["Crypto Usage Requirements"] = { selected: [], exclude: [] };
                }
                acc["Crypto Usage Requirements"].selected.push(label);
            } else if (crypto_usage_requirements[key] == "false") {
                // Add it to "excluded".
                if (!acc["Crypto Usage Requirements"]) {
                    acc["Crypto Usage Requirements"] = { selected: [], exclude: [] };
                }
                acc["Crypto Usage Requirements"].exclude.push(label);
            } else {
                console.log("Crypto Usage Requirement Parsing Error: ", key, crypto_usage_requirements[key])
            }
        }
        return acc;
    }, {}) : null;
}

function WalletRequirementCard(props) {

    // Fancy way to propercase titles. Overkill.
    String.prototype.toProperCase = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };

    const formatDate = (input) => {
        const date = new Date(input); // Handles both Date objects and datetime strings
        if (isNaN(date)) return "Invalid Date"; // Handle invalid input

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}/${month}/${day}`;
    };

    return (
        <div className="display-wallet-requirement-card">
            <div className="display-requirement-card-title">
                {props.requirement.human_name}
            </div>
            <div className="wallet-display-requirements-fields-container">
                {Object.keys(props.requirement).map((key) => {
                    if (["human_name", "id", "status", "type"].includes(key)) {
                        return null
                    } else if (props.requirement[key] == null) {
                        // Do nothing for now.
                    } else {
                        return (
                            <div className="wallet-display-requirements-field" key={key}>
                                <div className="wallet-display-requirements-field-title">
                                    {key.replace(/_/g, " ").toProperCase()}
                                </div>
                                <div className="wallet-display-requirements-field-value">
                                    {props.requirement[key].constructor == Object
                                        ? props.requirement[key]["label"]
                                        : (props.requirement[key].constructor == Date
                                            ? formatDate(props.requirement[key])
                                            : (["time_period_start", "time_period_end"].includes(key)
                                                ? formatDate(new Date(props.requirement[key]))
                                                : props.requirement[key]))}
                                </div>
                            </div>
                        )
                    }
                })}
            </div>
        </div>
    )
}

function DisplayRequirementCard(props) {

    // Fancy way to propercase titles. Overkill.
    String.prototype.toProperCase = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };

    function parseReqs() {
        // Check if it's a dictionary
        if (props.requirement && props.requirement.constructor == Object) {
            // Check if it's age
            if (("selected" in props.requirement) || ("exclude" in props.requirement)) {
                // It's not!
                return (
                    <>
                        {Object.keys(props.requirement).map((key) => {
                            const includedNameArray = props.requirement[key].map((id) => {
                                if (props.availableRequirements == null) {
                                    {/* Crypo Usage Requirement Hack */ }
                                    return { id: id, label: id }
                                } else {
                                    {/* All others */ }
                                    return props.availableRequirements.options.filter((option) => option.id == id)[0]
                                }
                            })

                            const titleClassName = key == "selected" ? "req-list-included" : "req-list-excluded"
                            const titleText = key == "selected" ? "Included:" : "Excluded:"

                            if (includedNameArray.length == 0) {
                                return null
                            } else {
                                return (
                                    <div className="req-list-container" key={"key-" + key}>
                                        <div key={key + "-title"} className={titleClassName}>
                                            {titleText}
                                        </div>
                                        {includedNameArray.map((country) => {
                                            return (
                                                <div key={"country-" + country["id"]} className="req-list-item">
                                                    {country["label"]}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })}
                    </>
                )
            } else if ("min" in props.requirement || "max" in props.requirement) {
                const ageType = "min" in props.requirement && "max" in props.requirement ? "between" : "min" in props.requirement ? "min" : "max"
                const titleText = ageType == "between" ? "Between:" : ageType == "min" ? "Greater than:" : "Less than:"
                const ageText = ageType == "between" ? props.requirement.min + " and " + props.requirement.max : ageType == "min" ? props.requirement.min : props.requirement.max
                return (
                    <div className="req-list-container" key="age-container">
                        <div key={"age--title"} className="req-list-neutral">
                            {titleText}
                        </div>
                        <div key={"age"} className="req-list-item">
                            {ageText}
                        </div>
                    </div>
                )

            }
        }

    }


    return (
        <div className="display-requirement-card">
            <div className="display-requirement-card-title">
                {(props.title).toProperCase()}
            </div>
            <div className="display-req-card-reqs-container">
                {/* Okay, it's one of four types. {exclude: [1,2,3]}, {included: [1,5,2]}, true, {min: 24, max: 39} */}
                {/* Check if hash: (a.constructor == Object) if not, then it's crypto. */}
                {parseReqs()}
            </div>
        </div>
    )

}

function TertiaryPlusLink(props) {
    return (
        <div className="tertiary-plus-link-container" onClick={props.onClick}  >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M6.91699 7.08073H6.41699H3.50033C3.47822 7.08073 3.45703 7.07195 3.4414 7.05632L3.08936 7.40836L3.4414 7.05632C3.42577 7.04069 3.41699 7.0195 3.41699 6.9974C3.41699 6.97529 3.42577 6.9541 3.4414 6.93847C3.45703 6.92284 3.47822 6.91406 3.50033 6.91406H6.41699H6.91699V6.41406V3.4974C6.91699 3.47529 6.92577 3.4541 6.9414 3.43847C6.95703 3.42284 6.97822 3.41406 7.00033 3.41406C7.02243 3.41406 7.04362 3.42284 7.05925 3.43847L7.4128 3.08492L7.05925 3.43847C7.07488 3.4541 7.08366 3.47529 7.08366 3.4974V6.41406V6.91406H7.58366H10.5003C10.5224 6.91406 10.5436 6.92284 10.5593 6.93847C10.5749 6.9541 10.5837 6.97529 10.5837 6.9974C10.5837 7.0195 10.5749 7.04069 10.5593 7.05632C10.5436 7.07195 10.5224 7.08073 10.5003 7.08073H7.58366H7.08366V7.58073V10.4974C7.08366 10.5195 7.07488 10.5407 7.05925 10.5563C7.04362 10.5719 7.02243 10.5807 7.00033 10.5807C6.97822 10.5807 6.95703 10.5719 6.9414 10.5563C6.92577 10.5407 6.91699 10.5195 6.91699 10.4974V7.58073V7.08073Z" fill="#B884FF" stroke="#B884FF" />
            </svg>
            <div className="tertiary-plus-link-text">
                {props.text}
            </div>
        </div>
    )
}

function TertiaryEditLink(props) {
    return (
        <div className="tertiary-plus-link-container" onClick={props.onClick}  >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M8.74967 3.50113L10.4997 5.25113M7.58301 11.6678H12.2497M2.91634 9.33446L2.33301 11.6678L4.66634 11.0845L11.4248 4.32596C11.6436 4.10718 11.7664 3.81048 11.7664 3.50113C11.7664 3.19177 11.6436 2.89507 11.4248 2.67629L11.3245 2.57596C11.1057 2.35724 10.809 2.23437 10.4997 2.23438C10.1903 2.23438 9.89362 2.35724 9.67484 2.57596L2.91634 9.33446Z" stroke="#B884FF" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div className="tertiary-plus-link-text">
                {props.text}
            </div>
        </div>
    )
}







export { AudienceRequirementsCard, WalletRequirementCard, AudienceRequirementsIndividualCard, parseCryptoUsageReqs, AudienceCardTitleAndSubtitle };
